import { COOKIE_JWT } from './constants'
import cookies from 'js-cookie'
import { settings, urls } from '../resources'

class fetchr {
  options = {}
  constructor(url, json) {
    const qs = /\?/.test(url) ? '&' : '?'
    const contentType = json ? { 'Content-Type': 'application/json; charset=UTF-8' } : {}
    this.options = {
      json,
      url: `${url}${qs}brand=${settings.language}`,
      headers: {
        ...contentType,
        Authorization: `bearer ${cookies.get(COOKIE_JWT)}`
      }
    }
  }
  post = payload => this.execute('POST', payload)
  delete = payload => this.execute('DELETE', payload)
  put = payload => this.execute('PUT', payload)
  get = () => this.execute('GET')
  execute = (method, payload) => {
    const body = payload ? { body: this.options.json ? JSON.stringify(payload) : payload } : {}
    const opts = { ...this.options, method, ...body }

    return fetch(opts.url, opts)
      .then(async response => {
        if (response.ok)
          return response

        if (response.status === 401) {
          window.location = `${urls.signIn}?status=401`
          cookies.remove(COOKIE_JWT)
          return Promise.reject('Unauthorized')
        }

        const json = await response.json()
        return Promise.reject(json)
      })
  }
}

export default (url, json = true) => new fetchr(url, json)